module.exports = __webpack_public_path__ + "img/footer-left-preview-infiniti.115b84e1.png";